import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import RmnAuditReportPage from '../pages/rmn/RmnAuditReportPage'
import RmnPrepPackPage from '../pages/rmn/RmnPrepPackPage'
import RmnPdpHistoryPage from '../pages/rmn/RmnPdpHistoryPage'
import RmnConsumerVoiceHistoryPage from '../pages/rmn/RmnConsumerVoiceHistoryPage'
import RmnAiPresenceHistoryPage from '../pages/rmn/RmnAiPresenceHistoryPage'
import RmnProposalPage from '../pages/rmn/RmnProposalPage'
import RmnProposalsPage from '../pages/rmn/RmnProposalsPage'
import RmnLegacyRedirect from '../pages/rmn/RmnLegacyRedirect'
import NetworkCategoriesPage from '../pages/network/NetworkCategoriesPage'
import NetworkBrandsListPage from '../pages/network/NetworkBrandsListPage'
import NetworkBrandsImportPage from '../pages/network/NetworkBrandsImportPage'
import NetworkProductsImportPage from '../pages/network/NetworkProductsImportPage'
import { ProductV2Listing } from '../pages/admin/productsV2/Products'

// The network/catalog page set (TDC-1499).
//
// It used to be mounted twice — slug-free in the brand routers and again,
// relativized, under /portal/:brandSlug. Since TDC-1609 the brand routers are
// themselves mounted under the portal (router/portalRoutes.tsx re-roots them
// through router/relativize.ts), so this is spread once, here, and the
// duplicate mount and its `relative`/`wrap` options are gone.
// The PDP Audit page is retired (phase 3): its report sections live on the
// Catalog pages and on product PDP URLs; only the deep-link viewer survives.
function networkRouteChildren(): RouteObject[] {
  return [
    { path: '/catalog/categories', element: <NetworkCategoriesPage /> },
    { path: '/catalog/brands', element: <NetworkBrandsListPage /> },
    // RMN networks only (page redirects non-RMN; API enforces too).
    {
      path: '/catalog/brands/discovered',
      element: <NetworkBrandsImportPage />,
    },
    { path: '/products', element: <ProductV2Listing /> },
    // What the analysis found but the client hasn't adopted (RMN networks
    // only; page redirects non-RMN).
    {
      path: '/products/discovered',
      element: <NetworkProductsImportPage />,
    },
    // Pre-rename paths.
    {
      path: '/catalog/brands/import',
      element: <Navigate to="../discovered" relative="path" replace />,
    },
    {
      path: '/products/import',
      element: <Navigate to="../discovered" relative="path" replace />,
    },
    // Retired page — old links land on the Catalog.
    {
      path: '/intelligence/pdp-audit',
      element: <RmnLegacyRedirect to="/catalog/categories" />,
    },
    {
      path: '/intelligence/pdp-audit/reports/:reportId',
      element: <RmnAuditReportPage />,
    },
    // Report histories for every brand plan (the reports run from the
    // Catalog pages).
    { path: '/intelligence/pdp-history', element: <RmnPdpHistoryPage /> },
    {
      path: '/intelligence/consumer-voice-history',
      element: <RmnConsumerVoiceHistoryPage />,
    },
    {
      path: '/intelligence/ai-presence-history',
      element: <RmnAiPresenceHistoryPage />,
    },
    // Network plans only (page redirects single brands).
    { path: '/intelligence/prep-packs', element: <RmnPrepPackPage /> },
    // "Strategies" is the brand-facing name for proposals (TDC-1499).
    { path: '/opportunities/strategies', element: <RmnProposalsPage /> },
    { path: '/opportunities/strategies/new', element: <RmnProposalPage /> },
  ]
}

export const NetworkRouteChildren: RouteObject[] = networkRouteChildren()
